import L from "leaflet";
import { Marker, Tooltip, Polyline, CircleMarker } from "react-leaflet";
import { reachedIndex } from "@/lib/travelPaths";
import { evDate } from "@/lib/eventDate";

const pos = (s) => [s.pin.y_coord, s.pin.x_coord];
const badge = (color, letter) => L.divIcon({
  className: "",
  html: `<div class="lf-traveller" style="background:${color}">${letter}</div>`,
  iconSize: [28, 28], iconAnchor: [14, 14],
});

function glide(stops, idx, t) {
  const a = stops[idx], b = stops[idx + 1];
  if (!a || !b || t == null || b.t <= a.t) return null;
  const f = Math.min(Math.max((t - a.t) / (b.t - a.t), 0), 1);
  const [ay, ax] = pos(a), [by, bx] = pos(b);
  return [ay + (by - ay) * f, ax + (bx - ax) * f];
}

const Path = ({ p, t, smooth }) => {
  const idx = reachedIndex(p.stops, t);
  const mid = smooth && idx >= 0 ? glide(p.stops, idx, t) : null;
  const done = p.stops.slice(0, idx + 1);
  const trail = mid ? [...done.map(pos), mid] : done.map(pos);
  const ahead = p.stops.slice(Math.max(idx, 0));
  const tag = (s) => `path-${p.entity.id}-${s.pin.id}-${s.t}`;
  return (
    <>
      {ahead.length > 1 && <Polyline positions={ahead.map(pos)} interactive={false} pathOptions={{ color: p.color, weight: 2, opacity: 0.35, dashArray: "3 7" }} />}
      {trail.length > 1 && <Polyline positions={trail} interactive={false} pathOptions={{ color: p.color, weight: 3.5, opacity: 0.95, dashArray: "10 6", lineCap: "round" }} />}
      {p.stops.map((s, i) => (
        <CircleMarker key={tag(s)} center={pos(s)} radius={i <= idx ? 7 : 5}
          pathOptions={{ color: "#0B0D10", weight: 2, fillColor: p.color, fillOpacity: i <= idx ? 1 : 0.35 }}
          eventHandlers={{ add: (e) => e.target.getElement()?.setAttribute("data-testid", `path-stop-${p.entity.id}-${i}`) }}>
          <Tooltip direction="top" offset={[0, -6]} className="lf-tip">
            <div className="font-medium">{i + 1}. {p.entity.name} · {s.pin.entity?.name || s.pin.label}</div>
            {s.events.map((e) => <div key={e.id} className="text-[11px] opacity-80">{evDate(e)} · {e.title}</div>)}
          </Tooltip>
        </CircleMarker>
      ))}
      {idx >= 0 && (
        <Marker position={mid || pos(p.stops[idx])} icon={badge(p.color, p.entity.name[0]?.toUpperCase() || "?")} zIndexOffset={1000}
          eventHandlers={{ add: (e) => e.target.getElement()?.setAttribute("data-testid", `path-traveller-${p.entity.id}`) }}>
          <Tooltip direction="right" offset={[12, 0]} className="lf-tip">{p.entity.name} — {p.stops[idx].pin.entity?.name || p.stops[idx].pin.label}</Tooltip>
        </Marker>
      )}
    </>
  );
};

export const TravelPathLayer = ({ paths, t, smooth }) => paths.map((p) => <Path key={p.entity.id} p={p} t={t} smooth={smooth} />);
